<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_tr1" :custom="{ storage: true }" export>
      <template v-slot:buttons>
        <el-button @click="funcExport()"> 导出 </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      export-config
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />

      <vxe-table-column
        field="originalOrderCode"
        title="运输单号"
        min-width="250"
      />

      <vxe-table-column field="orderCode" title="子单单号" min-width="250" />

      <vxe-table-column
        field="mainOrderNumber"
        title="货源单号"
        min-width="250"
      />
      <vxe-table-column field="dfName" title="经办人" min-width="130" />

      <vxe-table-column
        field="status"
        title="状态"
        :formatter="formatterStatus"
        min-width="130"
      />

      <vxe-table-column field="coalTypeName" title="货物类型" min-width="130" />

      <vxe-table-column field="coalName" title="运输要求" min-width="300" />

      <vxe-table-column
        field="taxPrice"
        title="托运人成交单价"
        min-width="200"
      />

      <vxe-table-column
        field="realPrice"
        title="实际承运人承运单价"
        min-width="200"
      />

      <vxe-table-column
        field="shipperDeliveryFee"
        title="托运人实际运费(元)"
        min-width="200"
      />

      <vxe-table-column
        field="deliveryFeePractical"
        title="实际承运人实收运费(元)"
        min-width="200"
      />

      <vxe-table-column field="coalPrice" title="货物单价" min-width="200" />

      <vxe-table-column field="distance" title="公里数(公里)" min-width="200" />

      <vxe-table-column
        field="loadWeight"
        title="装车数量(吨)"
        min-width="200"
      />

      <vxe-table-column
        field="unloadWeight"
        title="卸车数量(吨)"
        min-width="200"
      />
    </vxe-table>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { splitOrderList } from "@/api/transport";
export default {
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportSplitOrderList", //导出接口
        name: "子单详情"
      },
      loading: false,
      tableData: [],
      partyType: "",
      listQuery: {
        total: 0
      },
      sumObject: {},
      statusOptions: [
        { value: 1, label: "已接单" },
        { value: 2, label: "已装货" },
        { value: 3, label: "已卸货" },
        { value: 4, label: "已结算" },
        { value: 5, label: "已打款" }
      ]
    };
  },
  created() {
    this.partyType = this.$store.getters.party.partyType;
  },
  methods: {
    findList(code) {
      this.listQuery.originalCode = code;
      this.loading = true;
      return new Promise(resolve => {
        splitOrderList(this.listQuery)
          .then(response => {
            this.tableData = response.data.records;
            this.tableData.forEach(item => {
              item.taxPrice = item.taxPrice + "元/吨";
              item.realPrice = item.realPrice + "元/吨";
              item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            });
            this.listQuery.total = response.data.total;
            this.sumObject = response.data.sumObject;
            this.loading = false;
            resolve();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "deliveryFeePractical") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "taxFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "taxPayFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "deliveryOilFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "loadWeight") {
            return this.$XEUtils.sum(data, column.property) + "吨";
          }
          if (column.property === "unloadWeight") {
            return this.$XEUtils.sum(data, column.property) + "吨";
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style lang="scss" scoped>
.el-cascader {
  width: 100%;
}
</style>
